import styled, { css } from 'styled-components';
import { flex } from './Flex';

export const flexEvenly = css`
  ${flex};
  justify-content: space-evenly;
  align-items: center;
`;

export const FlexEvenly = styled.div`
  ${flexEvenly};
`;
